<template>
  <div class="entries-container">
    <div v-if="currentFilter === 'custom'" class="entry">
      <i class="icon-people_star"></i>
      <span class="caption">{{ $t('transportMode.custom') }}</span>
    </div>
    <div v-if="currentFilter === 'optimized'" class="entry">
      <i class="icon-chrono"></i>
      <span class="caption">{{ $t('transportMode.optimized') }}</span>
      <span class="details">({{ $t('transportMode.optimizedDetail') }})</span>
      <div class="repartition-container">
        <div class="item">
          <i class="icon icon-car"></i>
          <span class="value">
            <AnimatedValue :value="distribution.car" :to-fixed-value="0" :duration="0.4" />
          </span>
          <span class="percentage">%</span>
        </div>
        <div class="item">
          <i class="icon icon-bus"></i>
          <span class="value">
            <AnimatedValue :value="distribution.public" :to-fixed-value="0" :duration="0.4" />
          </span>
          <span class="percentage">%</span>
        </div>
      </div>
    </div>
    <div v-if="currentFilter === 'public'" class="entry">
      <i class="icon-bus"></i>
      <span class="caption">{{ $t('transportMode.public') }}</span>
      <span class="details">({{ $t('transportMode.actuals') }})</span>
    </div>
    <div v-if="currentFilter === 'public2025'" class="entry">
      <i class="icon-bus"></i>
      <span class="caption">{{ $t('transportMode.public') }}</span>
      <span class="details">({{ $t('transportMode.targetReach2025') }})</span>
    </div>
    <div v-if="currentFilter === 'public2030'" class="entry">
      <i class="icon-bus"></i>
      <span class="caption">{{ $t('transportMode.public') }}</span>
      <span class="details">({{ $t('transportMode.targetReach2030') }})</span>
    </div>
    <div v-if="currentFilter === 'public2027'" class="entry">
      <i class="icon-bus"></i>
      <span class="caption">{{ $t('transportMode.public') }}</span>
      <span class="details">({{ $t('transportMode.targetReach2027') }})</span>
    </div>
    <div v-if="currentFilter === 'public2031'" class="entry">
      <i class="icon-bus"></i>
      <span class="caption">{{ $t('transportMode.public') }}</span>
      <span class="details">({{ $t('transportMode.targetReach2031') }})</span>
    </div>
    <div v-if="currentFilter === 'private'" class="entry">
      <i class="icon-car"></i>
      <span class="caption">{{ $t('transportMode.private') }}</span>
      <span class="details">({{ $t('transportMode.withToll') }})</span>
    </div>
    <div v-if="currentFilter === 'private_without_toll'" class="entry">
      <i class="icon-car"></i>
      <span class="caption">{{ $t('transportMode.private') }}</span>
      <span class="details">({{ $t('transportMode.withoutToll') }})</span>
    </div>
    <div v-if="currentFilter === 'bicycle'" class="entry">
      <i class="icon-cycle"></i>
      <span class="caption">{{ $t('transportMode.bicycle') }}</span>
    </div>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimatedValue';
export default {
  components: {
    AnimatedValue,
  },

  props: ['currentFilter', 'distribution', 'index'],
};
</script>

<style lang="scss" scoped>
.repartition-container {
  margin: 48px 0 0 0;

  .item {
    display: flex;
    align-items: baseline;
    color: #fff;
    opacity: 0.5;

    .icon {
      padding: 0 0 24px;
    }
    .value {
      font-size: 96px;
    }
    .percentage {
      font-size: 48px;
    }
  }
}
</style>
